import { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import "../../css/ListScores.css";
import Footer from "../Navigation/Footer";
import FetchUtil from "../../utils/FetchUtil";
import AnalyticsHeader from "./AnalyticsHeader";
import DisplayScorePercent from "./DisplayScorePercent";
import { useNavigate, useLocation } from "react-router-dom";
import Select from 'react-select';
import { ddStyles } from "../../utils/CommonStyles.js";

let supplierOptions = [];
function SupplierAnalyticsChart() {
    const [errorValue, setErrorValue] = useState([]);
    const [supplierAnalytics, setSupplierAnalytics] = useState({});
    const [supplierAnalyticsFound, setSupplierAnalyticsFound] = useState(false);
    const [showScorePopup, setShowScorePopup] = useState(false);
    const { t } = useTranslation();
    const [popupAssessment, setPopupAssessment] = useState({});
    const [supplierCountArr, setSupplierCountArr] = useState([]);
    const [supplierId, setSupplierId] = useState(0);
    const [supplierSelected, setSupplierSelected] = useState({ name: "supplier", label: "", value: 0 });
    const navigate = useNavigate();
    const location = useLocation();
    //console.log(location.state);
    const directLanding = location.state.directLanding || "false";
    const delegates = location.state.delegates || [];

    useEffect(() => {
        if (delegates && delegates.length > 0) {
            setSupplierValues();
        }

    }, [delegates]);


    function setSupplierValues() {
        let supplierValue = {};
        supplierOptions = [];
        supplierOptions.push({ label: "", value: "" });
        if (delegates && delegates.length > 0) {
            delegates.map((delegate) => {
                supplierValue.label = delegate.parentCompanyName;
                supplierValue.value = delegate.companyId;
                supplierOptions.push(supplierValue);
				supplierValue = {};
            });
        }
        setSupplierSelected({ ...supplierSelected, label: "", value: 0 });
    }
    const supplierHandler = (selectedOption, action) => {
		setErrorValue([]);
        let selectedId = selectedOption ? selectedOption.value : 0;
        let selectedName = selectedOption ? selectedOption.label : "";
        setSupplierSelected({ ...supplierSelected, label: selectedName, value: selectedId });
        setSupplierAnalytics({});
        setSupplierAnalyticsFound(false);
        setSupplierId(selectedId);
        if (selectedId > 0) {
            fetchSupplierAnalytics();
        }
    }
    function fetchSupplierAnalytics() {
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ source: "web", supplierId: supplierId }),
        };
        try {
            FetchUtil.fetchAPI("MGetSupplierAnalytics", "/Service/QuestionService/GetSupplierAnalytics", requestOptions, getSupplierAnalyticsSuccess, getSupplierAnalyticsFail);
        } catch (error) {
            //console.log(error.message);
            setErrorValue([error.message]);
        }
    }

    function getSupplierAnalyticsFail(redirect) {
		setErrorValue([t("error.Analytics.NoSurvey")]);
        //console.log(t("error.getAnalyticsFailed"));
    }
    function getSupplierAnalyticsSuccess(responseData) {
        let supplierAnalyticsResponse;
        if (responseData) {
            supplierAnalyticsResponse = responseData.getSupplierAnalyticsResponse;
            if (supplierAnalyticsResponse && supplierAnalyticsResponse.errorCode === "0") {
                setSupplierAnalytics(supplierAnalyticsResponse);
                setSupplierAnalyticsFound(true);
                setSupplierCounts(supplierAnalyticsResponse);
				if(!supplierAnalyticsResponse || !supplierAnalyticsResponse.supplierAssessments 
					|| supplierAnalyticsResponse.supplierAssessments.length ==0){
						setErrorValue([t("error.Analytics.NoSurvey")]);
						
				}
            } else if (supplierAnalyticsResponse) {
                //setErrorValue([t("error.error") + " " + supplierAnalyticsResponse.errorMessage]);
				setErrorValue([t("error.Analytics.NoSurvey")]);
                console.log(t("error.error") + " " + supplierAnalyticsResponse.errorMessage);
            }
        }
    }
    function setSupplierCounts(supplierAnalyticsResponse) {
        let farmAnnualAssessCount = 0;
        let facilityAnnualAssessCount = 0;
        let shipmentAssessCount = 0;
        let finishedProductAssessCount = 0;
        let correctiveActionsCount = 0;
        let supplierCountObj = {
            supplierCount: 0,
            farmAnnualAssessCount: 0,
            facilityAnnualAssessCount: 0,
            shipmentAssessCount: 0,
            finishedProductAssessmentsCount: 0,
            correctiveActionCount: 0,
        }

        if (supplierAnalyticsResponse && supplierAnalyticsResponse.supplierAssessments && supplierAnalyticsResponse.supplierAssessments.length > 0) {
            supplierAnalyticsResponse.supplierAssessments.map((eachSupplierAssment, index) => {
                if (eachSupplierAssment && eachSupplierAssment.suppliers && eachSupplierAssment.suppliers.length > 0) {
                    supplierCountObj = {
                        supplierCount: eachSupplierAssment.suppliers.length,
                        farmAnnualAssessCount: 0,
                        facilityAnnualAssessCount: 0,
                        shipmentAssessCount: 0,
                        finishedProductAssessmentsCount: 0,
                        correctiveActionCount: 0,
                    }
                    farmAnnualAssessCount = 0;
                    facilityAnnualAssessCount = 0;
                    shipmentAssessCount = 0;
                    finishedProductAssessCount = 0;
                    correctiveActionsCount = 0;
                    eachSupplierAssment.suppliers.map((eachSupplier) => {
                        farmAnnualAssessCount += eachSupplier.farmAnnualAssessments.questionnaire.length;
                        facilityAnnualAssessCount += eachSupplier.facilityAnnualAssessments.questionnaire.length;
                        shipmentAssessCount += eachSupplier.shipmentAssessments.questionnaire.length;
                        finishedProductAssessCount += eachSupplier.finishedProductAssessments.questionnaire.length;
                        correctiveActionsCount += eachFacility.correctiveActions.questionnaire.length;
                    });
                    supplierCountObj.farmAnnualAssessCount = farmAnnualAssessCount;
                    supplierCountObj.facilityAnnualAssessCount = facilityAnnualAssessCount;
                    supplierCountObj.shipmentAssessCount = shipmentAssessCount;
                    supplierCountObj.finishedProductAssessmentsCount = finishedProductAssessCount;
                    supplierCountObj.correctiveActionCount = correctiveActionsCount;
                    supplierCountObj.push(facilityCountObj);
                    //alert("index: "+index+ " "+ JSON.stringify(facilityCountArray) );
                }
            });
        }
        setSupplierCountArr(supplierCountObj);
    }
    const displayScorePercent = (assessments) => {
        setPopupAssessment(assessments);
        setShowScorePopup(true);
    }

    function resetAssessment() {
        setPopupAssessment({});
    }

    const Box = ({ id, className, children }) => (
        <div id={id} className={className}>
            <span style={{ color: "white" }} >{children}</span>
        </div>
    );
    function handleClose() {
        setShowScorePopup(false);
        resetAssessment();
    }
    const onClickBack = (event) => {
        navigate("/pages/analyticsLanding");
    }

    return (
        <div className="container-fluid">
            <AnalyticsHeader />
            <div className={"container-fluid container_list viewh-85 qbg"}>
                <div className="row">
                    <div className="col">
                        <div
                            id="inerrorMessage"
                            className={
                                (errorValue && errorValue.length > 0) ? "errorblock" : "errorblock hide"
                            }
                        >
                            {(errorValue && errorValue.length > 0) ?
                                (
                                    errorValue.map((errorData) => (
                                        <p className="message-line">{errorData}</p>
                                    ))
                                ) : ""}
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <div id="placeholder_1" className="placeholder-pg"></div>
                    </div>
                </div>
                {(delegates && delegates.length > 0) ?
                    <div className="row">
                        <div className="col">
                            <div className="form-group search-dd-sm">
                                <label htmlFor="supplier" className="form-label">
                                    {t("page.supplier")}
                                    <span style={{ "color": "red", fontWeight: "bold" }}>*</span>
                                </label>
                                <Select
                                    name="supplier"
                                    id="supplier"
                                    options={supplierOptions}
                                    onChange={supplierHandler}
                                    placeholder={""}
                                    value={supplierSelected}
                                    isSearchable={true}
                                    className="myselect"
                                    inputId="supplier-input"
                                    styles={ddStyles}
                                />
                            </div>
                        </div>
                    </div>
                    : <div className="row">
                        <div className="col">

                        </div>
                    </div>
                }
                {(supplierAnalyticsFound && supplierAnalytics && supplierAnalytics.supplierAssessments && supplierAnalytics.supplierAssessments.length > 0) ?
                    supplierAnalytics.supplierAssessments.map((eachSupplierAssessment, supplierAssessIndx) => {
                        matchFound = false;
                        return (
                            <>
                                <div className="row">
                                    <div className="col text-start">
                                        <span style={{ fontWeight: "bold", fontSize: "18px" }}>{t("page.company.name")} : </span>{eachSupplierAssessment.companyName}
                                    </div>
                                </div>
                                <div className="row" >
                                    <div className="row-with-indicator">
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col text-start padd-tb10">
                                        <span style={{ fontWeight: "bold", fontSize: "15px" }}>{t("header.supply-chain")} </span>
                                    </div>
                                </div>
                                {supplierCountArr.length > 0 ?
                                    supplierCountArr.map((eachSupplierCount, supplierCountIndex) => {
                                        if (!matchFound) {
                                            if (supplierCountIndex === supplierAssessIndx) {
                                                matchFound = true;
                                            }
                                            if (matchFound) {
                                                return (
                                                    <>
                                                        <div className="row">
                                                            <div className="col">
                                                                <div className="box-container">
                                                                    <Box id="box7" className="box box-content1">{eachSupplierCount.supplierCount}<br></br> {t("page.supplier")}</Box>
                                                                    <i class="fa fa-arrow-right fa-2x" style={{ color: "#C0C0C0" }} ></i>
                                                                    <Box id="box8" className="box box-content1">{eachSupplierCount.farmAnnualAssessCount}<br></br> {t("page.farm.annual.assessments")}</Box>
                                                                    <i class="fa fa-arrow-right fa-2x" style={{ color: "#C0C0C0" }} ></i>
                                                                    <Box id="box8" className="box box-content1">{eachSupplierCount.facilityAnnualAssessCount}<br></br> {t("page.facility.annual.assessments")}</Box>
                                                                    <i class="fa fa-arrow-right fa-2x" style={{ color: "#C0C0C0" }} ></i>
                                                                    <Box id="box5" className="box box-content1">{eachSupplierCount.finishedProductAssessmentsCount}<br></br> {t("page.finished.product.assessments")}</Box>
                                                                    <i class="fa fa-arrow-right fa-2x" style={{ color: "#C0C0C0" }} ></i>
                                                                    <Box id="box6" className="box box-content1">{eachSupplierCount.correctiveActionCount}<br></br> {t("page.corr.action")}</Box>
                                                                    <i class="fa fa-arrow-right fa-2x" style={{ color: "#C0C0C0" }} ></i>
                                                                    <Box id="box11" className="box box-content1">{eachSupplierCount.shipmentAssessCount}<br></br> {t("page.shipment.assessments")}</Box>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="row-with-indicator padd-tb10">
                                                            </div>
                                                        </div>
                                                        <div className="row" >
                                                            <div className="row-with-indicator">
                                                            </div>
                                                        </div>
                                                        {eachSupplierAssessment.suppliers.map(eachSupplier => (
                                                            <div className="row padd-t10">
                                                                <div className="col">
                                                                    <span style={{ fontSize: "18px" }}>{eachSupplier.supplierName}</span>
                                                                </div>
                                                                {(eachSupplier.farmAnnualAssessments.scoreToDisplay === "H") ?
                                                                    <div className="co padd-0"><i class="fa fa-star fa-lg" style={{ color: "orange" }} onMouseOver={() => displayScorePercent(eachSupplier.farmAnnualAssessments)} onClick={() => displayScorePercent(eachSupplier.farmAnnualAssessments)} ></i></div> :
                                                                    (eachSupplier.farmAnnualAssessments.scoreToDisplay === "M") ?
                                                                        <div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "yellow" }} onMouseOver={() => displayScorePercent(eachSupplier.farmAnnualAssessments)} onClick={() => displayScorePercent(eachSupplier.farmAnnualAssessments)} ></i></div> :
                                                                        (eachSupplier.farmAnnualAssessments.scoreToDisplay === "L") ?
                                                                            <div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "green" }} onMouseOver={() => displayScorePercent(eachSupplier.farmAnnualAssessments)} onClick={() => displayScorePercent(eachSupplier.farmAnnualAssessments)} ></i></div> : <div className="col" />
                                                                }
                                                                {(eachSupplier.facilityAnnualAssessments.scoreToDisplay === "H") ?
                                                                    <div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "orange" }} onMouseOver={() => displayScorePercent(eachSupplier.facilityAnnualAssessments)} onClick={() => displayScorePercent(eachSupplier.facilityAnnualAssessments)} ></i></div> :
                                                                    (eachSupplier.facilityAnnualAssessments.scoreToDisplay === "M") ?
                                                                        <div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "yellow" }} onMouseOver={() => displayScorePercent(eachSupplier.facilityAnnualAssessments)} onClick={() => displayScorePercent(eachSupplier.facilityAnnualAssessments)} ></i></div> :
                                                                        (eachSupplier.facilityAnnualAssessments.scoreToDisplay === "L") ?
                                                                            <div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "green" }} onMouseOver={() => displayScorePercent(eachSupplier.facilityAnnualAssessments)} onClick={() => displayScorePercent(eachSupplier.facilityAnnualAssessments)} ></i></div> : <div className="col" />
                                                                }
                                                                {(eachSupplier.finishedProductAssessments.scoreToDisplay === "H") ?
                                                                    <div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "orange" }} onMouseOver={() => displayScorePercent(eachSupplier.finishedProductAssessments)} onClick={() => displayScorePercent(eachSupplier.finishedProductAssessments)} ></i></div> :
                                                                    (eachSupplier.finishedProductAssessments.scoreToDisplay === "M") ?
                                                                        <div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "yellow" }} onMouseOver={() => displayScorePercent(eachSupplier.finishedProductAssessments)} onClick={() => displayScorePercent(eachSupplier.finishedProductAssessments)} ></i></div> :
                                                                        (eachSupplier.finishedProductAssessments.scoreToDisplay === "L") ?
                                                                            <div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "green" }} onMouseOver={() => displayScorePercent(eachSupplier.finishedProductAssessments)} onClick={() => displayScorePercent(eachSupplier.finishedProductAssessments)} ></i></div> : <div className="col" />
                                                                }
                                                                {(eachSupplier.correctiveActions.scoreToDisplay === "H") ?
                                                                    <div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "orange" }} onMouseOver={() => displayScorePercent(eachSupplier.correctiveActions)} onClick={() => displayScorePercent(eachSupplier.correctiveActions)} ></i></div> :
                                                                    (eachSupplier.correctiveActions.scoreToDisplay === "M") ?
                                                                        <div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "yellow" }} onMouseOver={() => displayScorePercent(eachSupplier.correctiveActions)} onClick={() => displayScorePercent(eachSupplier.correctiveActions)} ></i></div> :
                                                                        (eachSupplier.correctiveActions.scoreToDisplay === "L") ?
                                                                            <div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "green" }} onMouseOver={() => displayScorePercent(eachSupplier.correctiveActions)} onClick={() => displayScorePercent(eachSupplier.correctiveActions)} ></i></div> : <div className="col" />
                                                                }
                                                                {(eachSupplier.shipmentAssessments.scoreToDisplay === "H") ?
                                                                    <div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "orange" }} onMouseOver={() => displayScorePercent(eachSupplier.shipmentAssessments)} onClick={() => displayScorePercent(eachSupplier.shipmentAssessments)} ></i></div> :
                                                                    (eachSupplier.shipmentAssessments.scoreToDisplay === "M") ?
                                                                        <div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "yellow" }} onMouseOver={() => displayScorePercent(eachSupplier.shipmentAssessments)} onClick={() => displayScorePercent(eachSupplier.shipmentAssessments)} ></i></div> :
                                                                        (eachSupplier.shipmentAssessments.scoreToDisplay === "L") ?
                                                                            <div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "green" }} onMouseOver={() => displayScorePercent(eachSupplier.shipmentAssessments)} onClick={() => displayScorePercent(eachSupplier.shipmentAssessments)} ></i></div> : <div className="col" />
                                                                }
                                                            </div>
                                                        ))}

                                                    </>
                                                );
                                            }
                                        }
                                    }) : null
                                }
                                <br />
                            </>
                        );
                    }) : <> </>
                }
                {showScorePopup ? <DisplayScorePercent assessment={popupAssessment} handleClose={handleClose} /> : <></>}
                {(!directLanding || directLanding !== "true") ?
                    <div className="row">
                        <div className="col">
                            <div style={{ "display": "inline-block" }}>
                                <button
                                    className="btn btn-primary btn-block search-button"
                                    onClick={onClickBack}
                                >
                                    <span class="fa fa-solid fa-chevron-left fa-2">{' '}</span>{t("page.back")}
                                </button>
                            </div>
                        </div>
                    </div> : null}
                <div className="row">
                    <div className="col">
                        <div
                            id="berrorMessage"
                            className={
                                (errorValue && errorValue.length > 0) ? "errorblock" : "errorblock hide"
                            }
                        >
                            {(errorValue && errorValue.length > 0) ? (
                                errorValue.map((errorData) => (
                                    <p className="message-line">{errorData}</p>
                                ))
                            ) : ""}
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer_container">
                <Footer />
            </div>
        </div>
    );
}

export default SupplierAnalyticsChart;